import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Plus } from "lucide-react";
import { ShowError, ShowSuccess } from "../../../../utils/ToasFunction";
import EditUnits from "../../../popup/editUnits";
import WarningPopup from "../../../popup/warning";
import ParagraphTag from "../../../reusebale/Paragraph";
import ButtonTag from "../../../reusebale/button";
import LabelTag from "../../../reusebale/label";
import UnitsCard from "../../../reusebale/uniCard";

import * as PropertyAction from "../../../../store/actions/property/PropertyAction";

import db from "../../../../db/index.json";
import { restrictToNumbersOnly } from "../../../../utils/inputUtils";

const PropertyUnits = () => {
  const { properties } = db;
  const dispatch = useDispatch();
  const { createNewPropertyBody, isUpdate } = useSelector(
    (state) => state.property
  );
  const [isHVAC, setIsHVAC] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const handleCheckboxChange = () => {
    setIsHVAC((prevState) => !prevState);
    setUnitFormFields({
      ...unitFormFields,
      hvac: !unitFormFields.hvac,
    });
  };

  const openPopup = () => {
    setIsEdit(true);
  };

  const closePopup = () => {
    setIsEdit(false);
  };

  const [warning, setWarning] = useState(false);
  const [unitId, setUnitId] = useState();

  const [unitFormFields, setUnitFormFields] = useState({
    numberOfUnits: 0,
    totalBuilding: 0,
    rent: 0,
    rentType: "Monthly",
    offices: 0,
    bathrooms: 0,
    size: 0,
    buildingDepth: 0,
    clearHeight: 0,
    parkingRation: 0,
    sprinklers: "",
    water: 0,
    electric: "",
    waltRollArea: 0,
    numberOfSuites: 0,
    lodingDocks: 0,
    gradeLevelDoors: 0,
    tenantSize: 0,
    yearBuild: 0,
    hvac: false,
    hvacValue: "",
    unitList: [],
  });

  function GenerateUnits(count) {
    const units = [];
    for (let i = 1; i <= count; i++) {
      units.push({
        id: i,
        unitName: `Unit ${i}`,
        totalBuilding: unitFormFields.totalBuilding,
        rent: unitFormFields.rent,
        rentType: unitFormFields.rentType,
        offices: unitFormFields.offices,
        bathrooms: unitFormFields.bathrooms,
        size: unitFormFields.size,
        buildingDepth: unitFormFields.buildingDepth,
        clearHeight: unitFormFields.clearHeight,
        parkingRation: unitFormFields.parkingRation,
        sprinklers: unitFormFields.sprinklers,
        water: unitFormFields.water,
        electric: unitFormFields.electric,
        waltRollArea: unitFormFields.waltRollArea,
        numberOfSuites: unitFormFields.numberOfSuites,
        lodingDocks: unitFormFields.lodingDocks,
        gradeLevelDoors: unitFormFields.gradeLevelDoors,
        tenantSize: unitFormFields.tenantSize,
        yearBuild: unitFormFields.yearBuild,
        hvac: unitFormFields.hvac,
        hvacValue: unitFormFields.hvacValue,
      });
    }
    ShowSuccess("Unit generated successfully");
    return units;
  }

  // Function to add a single unit in edit mode
  const addSingleUnit = () => {
    // Basic validation for essential fields only
    if (unitFormFields.rent === 0 || !unitFormFields.rent) {
      ShowError("Rent cannot be zero");
      return;
    }
    if (unitFormFields.size === 0 || !unitFormFields.size) {
      ShowError("Size cannot be zero");
      return;
    }

    // Get the next unit ID based on existing units
    const maxId =
      unitFormFields.unitList.length > 0
        ? Math.max(...unitFormFields.unitList.map((unit) => unit.id))
        : 0;

    const newUnits = GenerateUnits(1);

    const nextId = maxId + 1;
    const nextUnitNumber = unitFormFields.unitList.length + 1;

    newUnits[0].id = nextId;
    newUnits[0].unitName = `Unit ${nextUnitNumber}`;

    const updatedUnitList = [...unitFormFields.unitList, ...newUnits];
    setUnitFormFields({
      ...unitFormFields,
      unitList: updatedUnitList,
      numberOfUnits: updatedUnitList.length,
    });
  };

  const GenerateUnitsHandler = (e) => {
    e.preventDefault();
    if (unitFormFields.numberOfUnits === 0 || !unitFormFields.numberOfUnits) {
      ShowError("No. of units is required");
    } else if (unitFormFields.rent === 0 || !unitFormFields.rent) {
      ShowError("Rent cannot be zero");
    } else if (unitFormFields.size === 0 || !unitFormFields.size) {
      ShowError("Size cannot be zero");
    } else if (
      showInput[0].value &&
      (unitFormFields.totalBuilding == 0 || !unitFormFields.totalBuilding)
    ) {
      ShowError("Number of buildings are required");
    } else if (
      showInput[6].value &&
      (unitFormFields.buildingDepth == 0 || !unitFormFields.buildingDepth)
    ) {
      ShowError("Building depth is required");
    } else if (
      showInput[7].value &&
      (unitFormFields.clearHeight == 0 || !unitFormFields.clearHeight)
    ) {
      ShowError("Clear heigh is required");
    } else if (
      showInput[8].value &&
      (unitFormFields.parkingRation == 0 || !unitFormFields.parkingRation)
    ) {
      ShowError("Parking ration is required");
    } else if (showInput[9].value && !unitFormFields.sprinklers) {
      console.log(unitFormFields.sprinklers);
      ShowError("Sprinklers ration is required");
    } else if (
      showInput[10].value &&
      (unitFormFields.water == 0 || !unitFormFields.water)
    ) {
      ShowError("Water is required");
    } else if (
      showInput[11].value &&
      (unitFormFields.electric == 0 || !unitFormFields.electric)
    ) {
      ShowError("Electric is required");
    } else if (
      showInput[12].value &&
      (unitFormFields.numberOfSuites == 0 || !unitFormFields.numberOfSuites)
    ) {
      ShowError("Suits is required");
    } else if (
      showInput[13].value &&
      (unitFormFields.lodingDocks == 0 || !unitFormFields.lodingDocks)
    ) {
      ShowError("Loading docks is required");
    } else if (
      showInput[14].value &&
      (unitFormFields.gradeLevelDoors == 0 || !unitFormFields.gradeLevelDoors)
    ) {
      ShowError("Grade doors is required");
    } else if (
      showInput[15].value &&
      (unitFormFields.tenantSize == 0 || !unitFormFields.tenantSize)
    ) {
      ShowError("Tenant size is required");
    } else if (
      showInput[16].value &&
      (unitFormFields.yearBuild == 0 || !unitFormFields.yearBuild)
    ) {
      ShowError("Year build is required");
    } else if (
      showInput[17].value &&
      (unitFormFields.hvacValue == 0 || !unitFormFields.hvacValue)
    ) {
      ShowError("HVAC is required");
    } else {
      setUnitFormFields({
        ...unitFormFields,
        unitList: GenerateUnits(unitFormFields.numberOfUnits),
      });
    }
  };

  useEffect(() => {
    if (createNewPropertyBody.unitCreationFields) {
      const updatedUnitCreationFields = {
        ...createNewPropertyBody.unitCreationFields,
        unitList: createNewPropertyBody.unitData,
      };
      setUnitFormFields(updatedUnitCreationFields);
    }
  }, []);

  const [addUnits, setAddUnits] = useState(false);

  const NextHandler = (e) => {
    const { unitList, ...rest } = unitFormFields;

    e.preventDefault();
    dispatch(PropertyAction.ChangePropertyCreateSteps(4));
    dispatch(
      PropertyAction.CreatePropertyStepThreeAction(
        rest,
        unitFormFields.unitList
      )
    );
  };

  const BackHandler = (e) => {
    e.preventDefault();
    dispatch(PropertyAction.ChangePropertyCreateSteps(2));
  };
  const [showInput, setShowInput] = useState([
    {
      name: "Buildings",
      value: false,
    },

    {
      name: "Rent",
      value: true,
    },

    {
      name: "Rent Type",
      value: true,
    },

    {
      name: "Offices",
      value: true,
    },
    {
      name: "Bathrooms",
      value: true,
    },

    {
      name: "Size",
      value: true,
    },

    {
      name: "Building Depth",
      value: false,
    },
    {
      name: "Clear Height",
      value: false,
    },

    {
      name: "Parking Ratio",
      value: false,
    },
    {
      name: "Sprinklers",
      value: false,
    },
    {
      name: "Water",
      value: false,
    },
    {
      name: "Electric",
      value: false,
    },

    {
      name: "Suites",
      value: false,
    },
    {
      name: "Loading Docks",
      value: false,
    },

    {
      name: "Grade Doors",
      value: false,
    },

    {
      name: "Tenant Size",
      value: true,
    },

    {
      name: "Year Build",
      value: false,
    },

    {
      name: "HVAC",
      value: false,
    },
  ]);
  const PreCheckOnUdate = () => {
    let updatedList = [...showInput];
    for (const key in updatedList) {
      if (updatedList[key].name === "Buildings") {
        if (createNewPropertyBody?.unitCreationFields?.totalBuilding !== 0) {
          updatedList[key].value = true;
        }
      }

      if (updatedList[key].name === "HVAC") {
        if (
          createNewPropertyBody.unitCreationFields.hvacValue !== 0 &&
          createNewPropertyBody.unitCreationFields.hvacValue !== ""
        ) {
          updatedList[key].value = true;
        }
      }

      if (updatedList[key].name === "Building Depth") {
        if (createNewPropertyBody.unitCreationFields.buildingDepth !== 0) {
          updatedList[key].value = true;
        }
      }

      if (updatedList[key].name === "Clear Height") {
        if (createNewPropertyBody.unitCreationFields.clearHeight !== 0) {
          updatedList[key].value = true;
        }
      }

      if (updatedList[key].name === "Parking Ratio") {
        if (createNewPropertyBody.unitCreationFields.parkingRation !== 0) {
          updatedList[key].value = true;
        }
      }

      if (updatedList[key].name === "Sprinklers") {
        if (createNewPropertyBody.unitCreationFields.sprinklers !== 0) {
          updatedList[key].value = true;
        }
      }

      if (updatedList[key].name === "Water") {
        if (createNewPropertyBody.unitCreationFields.water !== 0) {
          updatedList[key].value = true;
        }
      }

      if (updatedList[key].name === "Electric") {
        if (createNewPropertyBody.unitCreationFields.electric !== 0) {
          updatedList[key].value = true;
        }
      }

      if (updatedList[key].name === "Suites") {
        if (createNewPropertyBody.unitCreationFields.numberOfSuites !== 0) {
          updatedList[key].value = true;
        }
      }

      if (updatedList[key].name === "Loading Docks") {
        if (createNewPropertyBody.unitCreationFields.lodingDocks !== 0) {
          updatedList[key].value = true;
        }
      }

      if (updatedList[key].name === "Grade Doors") {
        if (createNewPropertyBody.unitCreationFields.gradeLevelDoors !== 0) {
          updatedList[key].value = true;
        }
      }

      if (updatedList[key].name === "Tenant Size") {
        if (createNewPropertyBody.unitCreationFields.tenantSize !== 0) {
          updatedList[key].value = true;
        }
      }

      if (updatedList[key].name === "Year Build") {
        if (createNewPropertyBody.unitCreationFields.yearBuild !== 0) {
          updatedList[key].value = true;
        }
      }
    }
    setShowInput(updatedList);
  };

  useEffect(() => {
    if (isUpdate) {
      PreCheckOnUdate();
      setUnitFormFields(createNewPropertyBody.unitCreationFields);
      const updatedUnitCreationFields = {
        ...createNewPropertyBody.unitCreationFields,
        unitList: createNewPropertyBody.unitData,
      };
      setUnitFormFields(updatedUnitCreationFields);
    }
  }, [isUpdate, createNewPropertyBody]);

  const handleInputShow = (index, item) => {
    if (
      item === "Size" ||
      item === "Rent" ||
      item === "Rent Type" ||
      item === "Bathrooms" ||
      item === "Offices" ||
      item === "Tenant Size"
    ) {
      ShowError(`${item} is required`);
      return;
    }
    const updatedInputs = [...showInput];
    updatedInputs[index].value = !updatedInputs[index].value; // Value ko toggle karte hain
    setShowInput(updatedInputs);
  };

  const [selectedUnit, setSelectedUnit] = useState({
    id: 0,
    unitName: "",
    totalBuilding: 0,
    rent: 0,
    rentType: 0,
    offices: 0,
    bathrooms: 0,
    size: 0,
    buildingDepth: 0,
    clearHeight: 0,
    parkingRation: 0,
    sprinklers: 0,
    water: 0,
    electric: 0,
    waltRollArea: 0,
    numberOfSuites: 0,
    lodingDocks: 0,
    gradeLevelDoors: 0,
    tenantSize: 0,
    yearBuild: 0,
    hvac: false,
    hvacValue: 0,
  });

  function ReplaceSpecificUnit(list, newItem) {
    if (!Array.isArray(list)) {
      throw new Error("The first argument must be an array.");
    }
    if (!newItem || !newItem.id) {
      throw new Error("The newItem must be an object with an id property.");
    }

    return list.map((item) => (item.id === newItem.id ? newItem : item));
  }

  const onSaveHandler = (e) => {
    e.preventDefault();
    setUnitFormFields({
      ...unitFormFields,
      unitList: ReplaceSpecificUnit(unitFormFields.unitList, selectedUnit),
    });
    ShowSuccess("Unit item updated Successfully");
    setIsEdit(false);
  };

  useEffect(() => {
    if (isUpdate) {
    }
  }, []);

  return (
    <div className="w-full h-full">
      <div className="h-[10%] flex flex-col justify-center items-center">
        <ParagraphTag
          content="Unit Information (Optional)"
          classes="text-darkColor font-popinsSemiBold text-base 2xl:text-lg"
        />
        <div className="flex items-center gap-2 mt-2">
          <ParagraphTag
            content="Add Units"
            classes="text-[#686868] font-popinsRegular text-xs"
          />
          <button
            type="button"
            onClick={() => setAddUnits((prev) => !prev)}
            className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none ${
              addUnits ? "bg-themeColor" : "bg-gray-300"
            }`}
          >
            <span
              className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform ${
                addUnits ? "translate-x-6" : "translate-x-1"
              }`}
            />
          </button>
        </div>
      </div>
      <div className="h-[80%] w-full overflow-y-scroll panelScroll">
        {!addUnits && (
          <div className="flex flex-col items-center justify-center h-full text-center px-6">
            <ParagraphTag
              content="No units added yet"
              classes="text-darkColor/50 font-popinsMedium text-sm"
            />
            <ParagraphTag
              content="Turn on the toggle above to add units to this property. You can always add them later."
              classes="text-darkColor/30 font-popinsRegular text-xs mt-1"
            />
          </div>
        )}
        {addUnits && <>
        <div className="w-[85%] mx-auto pb-8">
          <div className="flex flex-wrap">
            {showInput.map((item, index) => (
              <div className="flex items-center w-[20%] mt-2">
                <input
                  type="checkbox"
                  className="w-4 bg-bgColor rounded-sm cursor-pointer"
                  checked={item.value}
                  onChange={() => handleInputShow(index, item.name)}
                />
                <ParagraphTag
                  content={item.name}
                  classes="text-darkColor text-sm pl-2 font-"
                />
              </div>
            ))}
          </div>
        </div>
        <div className="flex w-[95%] mx-auto justify-between h-full pt-2">
          <div className="w-[49%] overflow-y-scroll h-full panelScroll px-1 pb-2 ">
            <form className="property-form w-full">
              <div className="flex flex-wrap justify-between w-full">
                <div className="w-full">
                  <LabelTag
                    isStaric={false}
                    name="No. of Units"
                    classes="!text-xs !font-popinsMedium"
                  />
                  <input
                    value={unitFormFields.numberOfUnits}
                    onChange={(e) => {
                      setUnitFormFields({
                        ...unitFormFields,
                        numberOfUnits: e.target.value,
                      });
                    }}
                    onKeyPress={restrictToNumbersOnly}
                    type="number"
                    placeholder="Type here"
                    className="appearance-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none w-full mt-1 text-sm bg-bgColor border border-gray-300 font-popinsRegular px-3 py-2.5 rounded-md text-darkColor placeholder:text-gray-500 focus:outline-none focus:border-themeColor"
                  />
                </div>
              </div>
              <div className="flex justify-between">
                <div className="w-[49%]">
                  <LabelTag
                    isStaric={false}
                    name="Rent"
                    classes="!text-xs !font-popinsMedium"
                  />
                  <input
                    value={unitFormFields.rent}
                    onChange={(e) => {
                      setUnitFormFields({
                        ...unitFormFields,
                        rent: e.target.value,
                      });
                    }}
                    type="text"
                    placeholder="Type here"
                    className="w-full mt-1 text-sm bg-bgColor border border-gray-300 font-popinsRegular px-3 py-2.5 rounded-md text-darkColor placeholder:text-gray-500 focus:outline-none focus:border-themeColor"
                  />
                </div>
                <div className="w-[49%]">
                  <LabelTag
                    isStaric={false}
                    name="Rent Type"
                    classes="!text-xs !font-popinsMedium"
                  />
                  <select
                    value={unitFormFields.rentType}
                    onChange={(e) => {
                      setUnitFormFields({
                        ...unitFormFields,
                        rentType: e.target.value,
                      });
                    }}
                    className="w-full mt-1 text-sm bg-bgColor border border-gray-300 font-popinsRegular px-3 py-2.5 rounded-md text-darkColor placeholder:text-gray-500 focus:outline-none focus:border-themeColor"
                  >
                    <option>Yearly</option>
                    <option>Monthly</option>
                    <option>Quarterly</option>
                  </select>
                </div>
              </div>

              <div className="flex justify-between flex-wrap mt-2"></div>
              <div className="flex flex-wrap mt-2" id="gk-cards">
                {showInput[0].value && (
                  <div className="w-[32%] mr-[2%]">
                    <LabelTag
                      isStaric={false}
                      name="Total buildings in the park"
                      classes="!text-xs !font-popinsMedium"
                    />
                    <input
                      value={unitFormFields.totalBuilding}
                      onChange={(e) => {
                        setUnitFormFields({
                          ...unitFormFields,
                          totalBuilding: e.target.value,
                        });
                      }}
                      type="text"
                      placeholder="Type here"
                      className="w-full mt-1 text-sm bg-bgColor border border-gray-300 font-popinsRegular px-3 py-2.5 rounded-md text-darkColor placeholder:text-gray-500 focus:outline-none focus:border-themeColor"
                    />
                  </div>
                )}
                {showInput[3].value && (
                  <div className="w-[32%] mr-[2%]">
                    <LabelTag
                      isStaric={false}
                      name="Offices"
                      classes="!text-xs !font-popinsMedium"
                    />
                    <input
                      value={unitFormFields.offices}
                      onChange={(e) => {
                        setUnitFormFields({
                          ...unitFormFields,
                          offices: e.target.value,
                        });
                      }}
                      onKeyPress={restrictToNumbersOnly}
                      type="number"
                      placeholder="Type here"
                      className="appearance-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none w-full mt-1 text-sm bg-bgColor border border-gray-300 font-popinsRegular px-3 py-2.5 rounded-md text-darkColor placeholder:text-gray-500 focus:outline-none focus:border-themeColor"
                    />
                  </div>
                )}
                <div className="w-[32%] mr-[2%]">
                  <LabelTag
                    isStaric={false}
                    name="Bathrooms"
                    classes="!text-xs !font-popinsMedium"
                  />
                  <input
                    value={unitFormFields.bathrooms}
                    onChange={(e) => {
                      setUnitFormFields({
                        ...unitFormFields,
                        bathrooms: e.target.value,
                      });
                    }}
                    onKeyPress={restrictToNumbersOnly}
                    type="number"
                    placeholder="Type here"
                    className="appearance-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none w-full mt-1 text-sm bg-bgColor border border-gray-300 font-popinsRegular px-3 py-2.5 rounded-md text-darkColor placeholder:text-gray-500 focus:outline-none focus:border-themeColor"
                  />
                </div>
                <div className="w-[32%] mr-[2%]">
                  <LabelTag
                    isStaric={false}
                    name="Property Size (sqft)"
                    classes="!text-xs !font-popinsMedium"
                  />
                  <input
                    value={unitFormFields.size}
                    onChange={(e) => {
                      setUnitFormFields({
                        ...unitFormFields,
                        size: e.target.value,
                      });
                    }}
                    onKeyPress={restrictToNumbersOnly}
                    type="text"
                    placeholder="Type here"
                    className="appearance-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none w-full mt-1 text-sm bg-bgColor border border-gray-300 font-popinsRegular px-3 py-2.5 rounded-md text-darkColor placeholder:text-gray-500 focus:outline-none focus:border-themeColor"
                  />
                </div>
                {showInput[6].value && (
                  <div className="w-[32%] mr-[2%]">
                    <LabelTag
                      isStaric={false}
                      name="Building depth (%)"
                      classes="!text-xs !font-popinsMedium"
                    />
                    <input
                      value={unitFormFields.buildingDepth}
                      onChange={(e) => {
                        setUnitFormFields({
                          ...unitFormFields,
                          buildingDepth: e.target.value,
                        });
                      }}
                      onKeyPress={restrictToNumbersOnly}
                      type="number"
                      placeholder="Type here"
                      className="appearance-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none w-full mt-1 text-sm bg-bgColor border border-gray-300 font-popinsRegular px-3 py-2.5 rounded-md text-darkColor placeholder:text-gray-500 focus:outline-none focus:border-themeColor"
                    />
                  </div>
                )}
                {showInput[7].value && (
                  <div className="w-[32%] mr-[2%]">
                    <LabelTag
                      isStaric={false}
                      name="Clear height (%)"
                      classes="!text-xs !font-popinsMedium"
                    />
                    <input
                      value={unitFormFields.clearHeight}
                      onChange={(e) => {
                        setUnitFormFields({
                          ...unitFormFields,
                          clearHeight: e.target.value,
                        });
                      }}
                      onKeyPress={restrictToNumbersOnly}
                      type="number"
                      placeholder="Type here"
                      className="appearance-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none w-full mt-1 text-sm bg-bgColor border border-gray-300 font-popinsRegular px-3 py-2.5 rounded-md text-darkColor placeholder:text-gray-500 focus:outline-none focus:border-themeColor"
                    />
                  </div>
                )}

                {showInput[8].value && (
                  <div className="w-[32%] mr-[2%]">
                    <LabelTag
                      isStaric={false}
                      name="Parking Ratio"
                      classes="!text-xs !font-popinsMedium"
                    />
                    <input
                      value={unitFormFields.parkingRation}
                      onChange={(e) => {
                        setUnitFormFields({
                          ...unitFormFields,
                          parkingRation: e.target.value,
                        });
                      }}
                      type="text"
                      placeholder="Type here"
                      className="w-full mt-1 text-sm bg-bgColor border border-gray-300 font-popinsRegular px-3 py-2.5 rounded-md text-darkColor placeholder:text-gray-500 focus:outline-none focus:border-themeColor"
                    />
                  </div>
                )}
                {showInput[9].value && (
                  <div className="w-[32%] mr-[2%]">
                    <LabelTag
                      isStaric={false}
                      name="Sprinklers"
                      classes="!text-xs !font-popinsMedium"
                    />
                    <select
                      value={unitFormFields.sprinklers}
                      onChange={(e) => {
                        setUnitFormFields({
                          ...unitFormFields,
                          sprinklers: e.target.value,
                        });
                      }}
                      className="w-full mt-1 text-sm bg-bgColor border border-gray-300 font-popinsRegular px-3 py-2.5 rounded-md text-darkColor placeholder:text-gray-500 focus:outline-none focus:border-themeColor"
                    >
                      <option>Select Sprinklers</option>
                      <option>Yes</option>
                      <option>No</option>
                    </select>
                    {/* <input
                      value={unitFormFields.sprinklers}
                      onChange={(e) => {
                        setUnitFormFields({
                          ...unitFormFields,
                          sprinklers: e.target.value,
                        });
                      }}
                      type="text"
                      placeholder="Type here"
                      className="w-full mt-1 text-sm bg-bgColor border border-gray-300 font-popinsRegular px-3 py-2.5 rounded-md text-darkColor placeholder:text-gray-500 focus:outline-none focus:border-themeColor"
                    /> */}
                  </div>
                )}

                {showInput[10].value && (
                  <div className="w-[32%] mr-[2%]">
                    <LabelTag
                      isStaric={false}
                      name="Water"
                      classes="!text-xs !font-popinsMedium"
                    />
                    <input
                      value={unitFormFields.water}
                      onChange={(e) => {
                        setUnitFormFields({
                          ...unitFormFields,
                          water: e.target.value,
                        });
                      }}
                      type="text"
                      placeholder="Type here"
                      className="w-full mt-1 text-sm bg-bgColor border border-gray-300 font-popinsRegular px-3 py-2.5 rounded-md text-darkColor placeholder:text-gray-500 focus:outline-none focus:border-themeColor"
                    />
                  </div>
                )}

                {showInput[11].value && (
                  <div className="w-[32%] mr-[2%]">
                    <LabelTag
                      isStaric={false}
                      name="Electric"
                      classes="!text-xs !font-popinsMedium"
                    />
                    <select
                      value={unitFormFields.electric}
                      onChange={(e) => {
                        setUnitFormFields({
                          ...unitFormFields,
                          electric: e.target.value,
                        });
                      }}
                      className="w-full mt-1 text-sm bg-bgColor border border-gray-300 font-popinsRegular px-3 py-2.5 rounded-md text-darkColor placeholder:text-gray-500 focus:outline-none focus:border-themeColor"
                    >
                      <option>Select Electric</option>
                      <option>120/240V</option>
                      <option>208V</option>
                      <option>240V</option>
                      <option>480V</option>
                    </select>
                    {/* <input
                      value={unitFormFields.electric}
                      onChange={(e) => {
                        setUnitFormFields({
                          ...unitFormFields,
                          electric: e.target.value,
                        });
                      }}
                      type="text"
                      placeholder="Type here"
                      className="w-full mt-1 text-sm bg-bgColor border border-gray-300 font-popinsRegular px-3 py-2.5 rounded-md text-darkColor placeholder:text-gray-500 focus:outline-none focus:border-themeColor"
                    /> */}
                  </div>
                )}

                {showInput[12].value && (
                  <div className="w-[32%] mr-[2%]">
                    <LabelTag
                      isStaric={false}
                      name="# of Suites (%)"
                      classes="!text-xs !font-popinsMedium"
                    />
                    <input
                      value={unitFormFields.numberOfSuites}
                      onChange={(e) => {
                        setUnitFormFields({
                          ...unitFormFields,
                          numberOfSuites: e.target.value,
                        });
                      }}
                      type="text"
                      placeholder="Type here"
                      className="w-full mt-1 text-sm bg-bgColor border border-gray-300 font-popinsRegular px-3 py-2.5 rounded-md text-darkColor placeholder:text-gray-500 focus:outline-none focus:border-themeColor"
                    />
                  </div>
                )}
                {showInput[13].value && (
                  <div className="w-[32%] mr-[2%]">
                    <LabelTag
                      isStaric={false}
                      name="Loading docks #"
                      classes="!text-xs !font-popinsMedium"
                    />
                    <input
                      value={unitFormFields.lodingDocks}
                      onChange={(e) => {
                        setUnitFormFields({
                          ...unitFormFields,
                          lodingDocks: e.target.value,
                        });
                      }}
                      type="text"
                      placeholder="Type here"
                      className="w-full mt-1 text-sm bg-bgColor border border-gray-300 font-popinsRegular px-3 py-2.5 rounded-md text-darkColor placeholder:text-gray-500 focus:outline-none focus:border-themeColor"
                    />
                  </div>
                )}
                {showInput[14].value && (
                  <div className="w-[32%] mr-[2%]">
                    <LabelTag
                      isStaric={false}
                      name="Grade level doors"
                      classes="!text-xs !font-popinsMedium"
                    />
                    <input
                      value={unitFormFields.gradeLevelDoors}
                      onChange={(e) => {
                        setUnitFormFields({
                          ...unitFormFields,
                          gradeLevelDoors: e.target.value,
                        });
                      }}
                      type="text"
                      placeholder="Type here"
                      className="w-full mt-1 text-sm bg-bgColor border border-gray-300 font-popinsRegular px-3 py-2.5 rounded-md text-darkColor placeholder:text-gray-500 focus:outline-none focus:border-themeColor"
                    />
                  </div>
                )}

                {showInput[15].value && (
                  <div className="w-[32%] mr-[2%]">
                    <LabelTag
                      isStaric={false}
                      name="Tenant Size (Sqft)"
                      classes="!text-xs !font-popinsMedium"
                    />
                    <input
                      value={unitFormFields.tenantSize}
                      onChange={(e) => {
                        setUnitFormFields({
                          ...unitFormFields,
                          tenantSize: e.target.value,
                        });
                      }}
                      onKeyPress={restrictToNumbersOnly}
                      type="text"
                      placeholder="Type here"
                      className="w-full mt-1 text-sm bg-bgColor border border-gray-300 font-popinsRegular px-3 py-2.5 rounded-md text-darkColor placeholder:text-gray-500 focus:outline-none focus:border-themeColor"
                    />
                  </div>
                )}
                {showInput[16].value && (
                  <div className="w-[32%] mr-[2%]">
                    <LabelTag
                      isStaric={false}
                      name="Year built"
                      classes="!text-xs !font-popinsMedium"
                    />
                    <input
                      value={unitFormFields.yearBuild}
                      onChange={(e) => {
                        setUnitFormFields({
                          ...unitFormFields,
                          yearBuild: e.target.value,
                        });
                      }}
                      type="text"
                      placeholder="Type here"
                      className="w-full mt-1 text-sm bg-bgColor border border-gray-300 font-popinsRegular px-3 py-2.5 rounded-md text-darkColor placeholder:text-gray-500 focus:outline-none focus:border-themeColor"
                    />
                  </div>
                )}

                {showInput[17].value && (
                  <div className="w-[32%]">
                    <LabelTag
                      isStaric={false}
                      name="HVAC "
                      classes="!text-xs !font-popinsMedium"
                    />
                    <select
                      value={unitFormFields.hvacValue}
                      onChange={(e) => {
                        setUnitFormFields({
                          ...unitFormFields,
                          hvacValue: e.target.value,
                        });
                      }}
                      className="w-full mt-1 text-sm bg-bgColor border border-gray-300 font-popinsRegular px-3 py-2.5 rounded-md text-darkColor placeholder:text-gray-500 focus:outline-none focus:border-themeColor"
                    >
                      <option>Select HVAC</option>
                      <option>Yes</option>
                      <option>No</option>
                    </select>
                    {/* <input
                      value={unitFormFields.hvacValue}
                      onChange={(e) => {
                        setUnitFormFields({
                          ...unitFormFields,
                          hvacValue: e.target.value,
                        });
                      }}
                      type="number"
                      placeholder="Type here"
                      className="appearance-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none w-full mt-1 text-sm bg-bgColor border border-gray-300 font-popinsRegular px-3 py-2.5 rounded-md text-darkColor placeholder:text-gray-500 focus:outline-none focus:border-themeColor"
                    /> */}
                  </div>
                )}
              </div>
            </form>
          </div>
          <div className="w-[2%] flex justify-center">
            <div className="h-full w-[1px] bg-black/20"></div>
          </div>
          <div className="w-[49%] overflow-y-scroll h-full panelScroll">
            {/* Add unit button - only visible in edit mode */}
            {isUpdate && (
              <div className="w-full mb-4">
                <button
                  onClick={addSingleUnit}
                  className="font-popinsMedium py-2 flex justify-center items-center w-full text-sm border border-themeColor text-themeColor rounded-md hover:bg-themeColor hover:text-white transition-colors duration-200"
                >
                  <Plus color="currentColor" size={18} />
                  <span className="pl-2">Add Unit</span>
                </button>
              </div>
            )}
            {unitFormFields?.unitList?.map((item, i) => (
              <UnitsCard
                isDeleteShow={true}
                onDelete={(item) => {
                  setUnitId(item.id);
                  setWarning(true);
                }}
                data={item}
                classes="w-full my-2 py-3 px-2 cursor-pointer"
                onTrigger={() => {
                  setSelectedUnit(item);
                  openPopup();
                }}
                isDelete={true}
              />
            ))}
          </div>
        </div>
        </>}
      </div>
      <div className="h-[10%] flex justify-center items-center">
        <div className="w-[50%] flex justify-center items-center">
          {addUnits && !isUpdate && (
            <button
              onClick={GenerateUnitsHandler}
              className="font-popinsMedium py-2 flex justify-center items-center w-[30%] text-sm border border-themeColor text-themeColor rounded-md"
            >
              <Plus color="#0381CA" size={18} />
              <span className="pl-2">Generate units</span>
            </button>
          )}
        </div>
        <div className="w-[50%] mx-auto flex justify-center items-center gap-4">
          <ButtonTag
            onSubmit={BackHandler}
            name="Back"
            classes="text-base text-center bg-gray-500 text-white !w-[40%]"
          />
          <ButtonTag
            onSubmit={NextHandler}
            name="Next"
            classes="text-base text-center bg-themeColor text-white !w-[40%]"
          />
        </div>
      </div>
      {isEdit && (
        <EditUnits
          selectedUnit={selectedUnit}
          onSave={onSaveHandler}
          onBack={closePopup}
          unitNameValue={selectedUnit.unitName}
          buildingValue={selectedUnit?.totalBuilding}
          rentValue={selectedUnit?.rent}
          rentTypeValue={selectedUnit.rentType}
          officesValue={selectedUnit.offices}
          bathroomsValue={selectedUnit.bathrooms}
          sizeValue={selectedUnit.size}
          buildingDepthValue={selectedUnit.buildingDepth}
          clearHeightValue={selectedUnit.clearHeight}
          parkingRationValue={selectedUnit.parkingRation}
          sprinklersValue={selectedUnit.sprinklers}
          waterValue={selectedUnit.water}
          electricValue={selectedUnit.electric}
          waltRollAreaValue={selectedUnit.waltRollArea}
          noOfSuitsValue={selectedUnit.numberOfSuites}
          loadingDocksValue={selectedUnit.lodingDocks}
          gradeLevelDoorsValue={selectedUnit.gradeLevelDoors}
          yearBuildValue={selectedUnit.yearBuild}
          tenantsSizeValue={selectedUnit.tenantSize}
          hvacValue={selectedUnit.hvac}
          hvacNumberValue={selectedUnit.hvacValue}
          unitNameValueChange={(e) => {
            setSelectedUnit({
              ...selectedUnit,
              unitName: e.target.value,
            });
          }}
          buildingValueChange={(e) => {
            setSelectedUnit({
              ...selectedUnit,
              totalBuilding: e.target.value,
            });
          }}
          rentValueChange={(e) => {
            setSelectedUnit({
              ...selectedUnit,
              rent: e.target.value,
            });
          }}
          renttypeValueChange={(e) => {
            setSelectedUnit({
              ...selectedUnit,
              rentType: e.target.value,
            });
          }}
          officesValueChange={(e) => {
            setSelectedUnit({
              ...selectedUnit,
              offices: e.target.value,
            });
          }}
          bathroomsValueChange={(e) => {
            setSelectedUnit({
              ...selectedUnit,
              bathrooms: e.target.value,
            });
          }}
          sizeValueChange={(e) => {
            setSelectedUnit({
              ...selectedUnit,
              size: e.target.value,
            });
          }}
          buildingDepthChange={(e) => {
            setSelectedUnit({
              ...selectedUnit,
              buildingDepth: e.target.value,
            });
          }}
          clearHeighValueChange={(e) => {
            setSelectedUnit({
              ...selectedUnit,
              clearHeight: e.target.value,
            });
          }}
          parkingRationValueChange={(e) => {
            setSelectedUnit({
              ...selectedUnit,
              parkingRation: e.target.value,
            });
          }}
          sprinklersValueChange={(e) => {
            setSelectedUnit({
              ...selectedUnit,
              sprinklers: e.target.value,
            });
          }}
          waterValueChange={(e) => {
            setSelectedUnit({
              ...selectedUnit,
              water: e.target.value,
            });
          }}
          electricValueChange={(e) => {
            setSelectedUnit({
              ...selectedUnit,
              electric: e.target.value,
            });
          }}
          waltRollAreaValueChange={(e) => {
            setSelectedUnit({
              ...selectedUnit,
              waltRollArea: e.target.value,
            });
          }}
          noOfSuitsValueChange={(e) => {
            setSelectedUnit({
              ...selectedUnit,
              numberOfSuites: e.target.value,
            });
          }}
          loadingDocksValueChange={(e) => {
            setSelectedUnit({
              ...selectedUnit,
              lodingDocks: e.target.value,
            });
          }}
          gradeLevelDoorsValueChange={(e) => {
            setSelectedUnit({
              ...selectedUnit,
              gradeLevelDoors: e.target.value,
            });
          }}
          tenantsSizeValueChange={(e) => {
            setSelectedUnit({
              ...selectedUnit,
              tenantSize: e.target.value,
            });
          }}
          yearBuildValueChange={(e) => {
            setSelectedUnit({
              ...selectedUnit,
              yearBuild: e.target.value,
            });
          }}
          hvacValueChange={(e) => {
            setSelectedUnit({
              ...selectedUnit,
              hvac: !selectedUnit.hvac,
            });
          }}
          hvacNumberValueChange={(e) => {
            setSelectedUnit({
              ...selectedUnit,
              hvacValue: e.target.value,
            });
          }}
        />
      )}
      {warning && (
        <WarningPopup
          onDeleteItem={() => {
            let list = [...unitFormFields.unitList];
            const filterList = list.filter((i) => i.id !== unitId);
            setUnitFormFields({
              ...unitFormFields,
              unitList: filterList,
              numberOfUnits: filterList.length,
            });
            setWarning(false);
            setUnitId();
            ShowSuccess("Unit deleted successfully");
          }}
          onClose={() => {
            setWarning(false);
          }}
        />
      )}
    </div>
  );
};

export default PropertyUnits;
